type ErrorMessageOptions = {
  genericErrorMessage: string;
  malformedCsvErrorMessage: string;
  formatMalformedCsvLineErrorMessage: (line: string) => string;
  confirmStateErrorMessage?: string;
  rowGenericErrorMessage?: string;
};

type ErrorMessageContext = 'general' | 'row';

const getFallbackMessage = (options: ErrorMessageOptions, context: ErrorMessageContext) => {
  if (context === 'row') {
    return options.rowGenericErrorMessage || options.genericErrorMessage;
  }
  return options.genericErrorMessage;
};

export const normalizeBatchInvitationErrorMessage = (
  rawMessage: unknown,
  options: ErrorMessageOptions,
  context: ErrorMessageContext = 'general'
): string => {
  const message = String(rawMessage || '').trim();
  if (!message) {
    return getFallbackMessage(options, context);
  }

  const malformedCsvWithLineMatch = message.match(/(?:malformed\s*csv|illegal\s*quoting).*line\s+(\d+)/i);
  if (malformedCsvWithLineMatch?.[1]) {
    return options.formatMalformedCsvLineErrorMessage(malformedCsvWithLineMatch[1]);
  }

  if (/(malformed\s*csv|illegal\s*quoting)/i.test(message)) {
    return options.malformedCsvErrorMessage;
  }

  if (options.confirmStateErrorMessage && /already\s+confirmed|invalid\s+state/i.test(message)) {
    return options.confirmStateErrorMessage;
  }

  if (/unprocessable\s+entity/i.test(message)) {
    const cleanedMessage = message.replace(/unprocessable\s+entity\s*[-:]*\s*/i, '').trim();
    if (cleanedMessage && cleanedMessage.toLocaleLowerCase() !== message.toLocaleLowerCase()) {
      return normalizeBatchInvitationErrorMessage(cleanedMessage, options, context);
    }
    return getFallbackMessage(options, context);
  }

  if (/(error[_\s-]?code|cli_|auth-)/i.test(message)) {
    return getFallbackMessage(options, context);
  }

  return message;
};
